<template>  
  <div class="registration-test test">
    <h3>Registration Test</h3>
    <ul>
      <li>Firebase Ready: {{ firebaseReady ? "Werks." : "..." }}</li>
      <li>Eternal Ready: {{ eternalReady ? "Werks." : "..." }}</li>
      <li><a href="" @click.prevent="showTokens = true">View Tokens</a></li>
    </ul>
    <a v-if="eternalError !== '' && errorClosed" @click.prevent="errorClosed = false">Show Error</a>
    <div v-if="eternalError !== '' && !errorClosed" class="registration-error">
      <a class="error-exit" href="" @click.prevent="errorClosed = true">Exit</a>
      <code>{{ eternalError }}</code>
    </div>
    <div v-if="showTokens" class="registration-tokens">
      <a class="token-exit" href="" @click.prevent="showTokens = false">Exit</a>
      <ul>
        <li>Firebase Token: {{ firebaseToken !== null ? firebaseToken : '...'}}</li>
        <li>Eternal Token: {{ eternalToken !== null ? eternalToken : '...'}}</li>
        <li>Ephemeral Token: {{ ephemeralToken !== null ? ephemeralToken : '...'}}</li>
      </ul>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  
  export default {
    data: function () {
      return {
        showTokens: false,
        errorClosed: false
      }
    },
    computed: {
      ...mapGetters([
        'eternalToken',
        'ephemeralToken',
        'firebaseReady',
        'firebaseToken',
        'eternalError',
        'eternalReady'
      ])
    },
    mounted () {
      this.$store.dispatch('registerFirebase')
    }
  }
</script>
<style lang="less">
  .registration-test {
    padding: 2em;
    h3 {
      margin-top: 0;
    }
  }

  @data-margin: 32px;

  .error-exit {
    display: block;
    width: 100%;
    text-align: right;
  }

  .registration-error {
    padding: 1em;
    position: fixed;
    top: @data-margin + 2px;
    bottom: @data-margin + 2px;
    right: @data-margin + 2px;
    left: @data-margin + 2px;
    z-index: 1;
    border: 1px solid red;
  }

  .registration-error:before {
    content: " ";
    position: fixed;
    background-color: black;
    z-index: -1;
    top: @data-margin;
    bottom: @data-margin;
    right: @data-margin;
    left: @data-margin;

    border: 1px solid red;
  }

  .token-exit {
    display: block;
    width: 100%;
    text-align: right;
  }

  .registration-tokens {
    padding: 1em;
    position: fixed;
    top: @data-margin + 2px;
    bottom: @data-margin + 2px;
    right: @data-margin + 2px;
    left: @data-margin + 2px;
    z-index: 1;
    border: 1px solid green;
  }

  .registration-tokens:before {
    content: " ";
    position: fixed;
    background-color: black;
    z-index: -1;
    top: @data-margin;
    bottom: @data-margin;
    right: @data-margin;
    left: @data-margin;

    border: 1px solid green;
  }

</style>



// WEBPACK FOOTER //
// src/components/MockEphemeralTests.vue